import React from "react";
import { useNavigate } from "react-router-dom";
import RenewalLayout from "../../components/RenewalLayout";

const shimmer =
  "relative overflow-hidden bg-[#E5E9EB] before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const PersonalAccidentRenewalSkeleton = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>
      <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll">
        <RenewalLayout
          policyType="personalAccident"
          show_close_btn={false}
          is_hide_back_btn={false}
          backClickHandler={() => navigate("/renew")}
          is_bottom_sticky_layout={false}
        >
          <div className="flex flex-col items-center mx-auto max-w-lg max767:px-[22px] pt-0 w-full">
            <div className="flex justify-center items-center w-full">
              <div className="p-0 w-full">
                {/* Title — mirrors TitleDescription h1 (text-2xl leading-8 mb-2) */}
                <div className="max767:mt-2">
                  <Bar className="h-8 w-48 mb-2" />
                  {/* Description — mirrors TitleDescription p (text-base leading-6 mb-4) */}
                  <Bar className="h-5 w-4/5 mb-4" />
                </div>

                {/* Form fields */}
                <div className="mt-8 space-y-6 max767:pb-28">
                  {/* Policy Limit — one block label + input with endAdornment */}
                  <div>
                    {/* label: "Policy Limit (max BHD 25,000)" — one line */}
                    <Bar className="h-[26px] w-64 mb-2" />
                    {/* Input with flag+BHD endAdornment on right */}
                    <div className="relative">
                      <Bar className="h-[50px] w-full rounded-lg" />
                      <div className="absolute right-3 rtl:left-3 rtl:right-auto top-1/2 -translate-y-1/2 flex items-center gap-2 pointer-events-none">
                        <Bar className="h-5 w-5 rounded-full" />
                        <Bar className="h-4 w-8" />
                      </div>
                    </div>
                  </div>

                  {/* Occupation — label + react-select (h-[38px]) */}
                  <div>
                    <Bar className="h-[26px] w-28 mb-2" />
                    <Bar className="h-[38px] w-full rounded-lg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </RenewalLayout>
      </div>

      {/* Sticky footer — exact classes from BottomStickyBtnLayout */}
      <div className="footer bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-end fixed pr-10 bottom-0 z-[50] max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:inset-x-0 ipad:items-center max767:inline-block">
        <div className="flex justify-end pr-0 max767:w-full">
          <Bar className="w-[200px] h-[52px] rounded-[10px] max767:w-full max767:h-[48px]" />
        </div>
      </div>
    </>
  );
};

export default PersonalAccidentRenewalSkeleton;
